// extracted by mini-css-extract-plugin
module.exports = {"bottom":"CommonEndingQuestions_bottom___rvD1"};